import request from '@/lib/request.mjs';

export default async function () {
  const { permissions } = await request('getUserPermissions');
  return permissions;
}
